import { mapGetters } from "vuex";
import { MODULES } from "@/config";

export const errorMixin = {
  data() {
    return {
      error: null,
    };
  },
  computed: {
    ...mapGetters(MODULES.PAYMENT, {
      paymentError: "getPaymentError",
    }),
    ...mapGetters(MODULES.USER, {
      userError: "getUserError",
    }),
  },
  watch: {
    paymentError(newError) {
      let err = newError?.error || newError;

      this.setError(err);
    },
    userError(newError) {
      let err = newError?.message || newError?.error;

      this.setError(err);
    },
  },
  methods: {
    setError(newError) {
      this.error = newError;
    },
  },
};
